import { DTOError } from 'src/error/errors/DTOError';

import type { ActualizationChanges } from './types';

import { miscDataDTO } from '../package/miscDataDTO';
import { extrasDTO } from '../package/extrasDTO';

export const actualizationChangesDTO = (
  data: unknown,
): ActualizationChanges => {
  if (data && typeof data === 'object') {
    return {
      nights_count:
        'nights_count' in data
          ? actualizationChangeDTO(data.nights_count, 'number')
          : undefined,
      net_price:
        'net_price' in data
          ? actualizationChangeDTO(data.net_price, 'number')
          : undefined,
      transfer:
        'transfer' in data
          ? actualizationChangeDTO(data.transfer, 'boolean')
          : undefined,
      misc_data:
        'misc_data' in data
          ? actualizationChangeDTO(data.misc_data, 'object', miscDataDTO)
          : undefined,
      extras:
        'extras' in data
          ? actualizationChangeDTO(data.extras, 'object', extrasDTO)
          : undefined,
      accommodation_availability:
        'accommodation_availability' in data
          ? actualizationChangeDTO(data.accommodation_availability, 'string')
          : undefined,
      stat_currency_name:
        'stat_currency_name' in data
          ? actualizationChangeDTO(data.stat_currency_name, 'string')
          : undefined,
      stat_exchange_rate:
        'stat_exchange_rate' in data
          ? actualizationChangeDTO(data.stat_exchange_rate, 'number')
          : undefined,
    };
  }

  throw new DTOError('actualizationChangesDTO', data);
};

const actualizationChangeDTO = <T>(
  data: unknown,
  type: string,
  nestedDTO?: (changedData: unknown) => T,
): T[] | undefined => {
  if (
    !data ||
    !Array.isArray(data) ||
    data.length !== 2 ||
    !(!data[0] || typeof data[0] === type) ||
    typeof data[1] !== type
  ) {
    return undefined;
  }

  return [
    nestedDTO ? nestedDTO(data[0]) : (data[0] as T),
    nestedDTO ? nestedDTO(data[1]) : (data[1] as T),
  ];
};
